<template>
  <div
    v-if="show"
    class="indicator-container"
  >
      <img
        :class="{'message-picto': true, default: !avatar, noBackground}"
        :src="avatar" :alt="name" />
    <div :class="['typing-indicator', { noBackground }]">
      <div v-if="!noBackground" class="small-arrow"></div>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TypingIndicator',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    avatar: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    noBackground: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show (show) {
      if (show) {
        this.$emit('scrollToEnd')
      }
    }
  }
}
</script>

<style scoped lang="postcss">
.indicator-container {
  display: flex;
  flex-direction: row;
  width: 200px;
  height: 42px;
  padding: 0 10px;
}

.message-picto {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: 8px;
  background: white;
  align-self: flex-start;
  overflow: hidden;
  padding: 2px;

  &.default {
    width: 32px;
    height: 32px;
  }

  &.noBackground {
    background: transparent;
  }
}


.typing-indicator {
  will-change: transform;
  display: table;
  position: relative;
  animation: 2s bulge infinite ease-out;
  border-radius: 10px;
  background-color: white;
  padding: 5px;
  width: auto;
  margin-top: 15px;

  &.noBackground {
    background: transparent;
  }

  .small-arrow {
    position: absolute;
    transform: rotate(45deg);
    background-color: white;
    width: 10px;
    height: 10px;
    left: -3px;
    top: 15px;
  }
}
.typing-indicator span {
  height: 8px;
  width: 8px;
  float: left;
  margin: 5px 3px;
  background-color: #9e9ea1;
  display: block;
  border-radius: 50%;
  opacity: 0.4;
}
.typing-indicator span:nth-of-type(1) {
  animation: 1s blink infinite 0.3333s;
}
.typing-indicator span:nth-of-type(2) {
  animation: 1s blink infinite 0.6666s;
}
.typing-indicator span:nth-of-type(3) {
  animation: 1s blink infinite 0.9999s;
}

@keyframes blink {
  50% {
    opacity: 1;
  }
}
@keyframes bulge {
  50% {
    transform: scale(1.05);
  }
}

</style>
